import { render, staticRenderFns } from "./WorkspaceViewPage.vue?vue&type=template&id=012cc7a4&"
import script from "./WorkspaceViewPage.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceViewPage.vue?vue&type=style&index=0&id=012cc7a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports